/**
 * Urgency / timeline — shared across infra leasing post-requirement and enquiry flows.
 */
export const URGENCY_OPTIONS = [
  { value: 'immediate', label: 'Immediate (within 1 week)' },
  { value: 'within_one_month', label: 'Within 1 Month' },
  { value: 'within_three_months', label: 'Within 3 Months' },
  { value: 'flexible', label: 'Flexible Timeline' },
];

export function formatInfrastructureLeasingUrgency(value) {
  const key = value == null ? '' : String(value).trim();
  if (!key) return '—';
  const hit = URGENCY_OPTIONS.find((o) => o.value === key);
  return hit ? hit.label : key.replace(/_/g, ' ');
}
